import http from '@/utils/http'
import store from '@/vuex/store'
// 授权登录接口 根据用户token获取用户信息
export const oAuth = (token) => http.post('/marking-login/login/school_login_token?token=' + token)

// 获取历史学年用户角色
export const getMyRole = (userId) => http.get(`/marking-platform/user-roles/history/school-user-role/${userId}`)
export const getHistoryYear = (params) => http.get('/marking-platform/school/upgrade-history', params, 'form') // 获取学校历史学年

// 学科网登录
export const ssoCheck = (host) => http.jsonp(host + '/user/info')
export const ssoLogin = () => http.get('/marking-login/sso/token?loginType=SCHOOL')

export const checkRolesChange = params => {
  const key = 'canCheckRolesChange'
  // 防止同一时刻多次请求
  setTimeout(() => {
    YJ_SCHOOL_STORAGE.removeItem(key)
  }, 5 * 1000)
  if (!YJ_SCHOOL_STORAGE.getItem(key)) {
    YJ_SCHOOL_STORAGE.setItem(key, 'NO')
    return http.get('/marking-platform/permissions/valid/change', params)
  } else {
    return Promise.resolve({ body: false })
  }
} // 检查用户角色是否发生变化

// 获取用户角色
export const getRoles = user => http.get('/marking-platform/permissions/user/roles', { userId: user.userId, schoolId: user.schoolId }).then(resp => {
  if (resp.body) {
    const { roles, perms, orgPermVersion, templatePermVersion } = resp.body
    user.roles = roles || []
    user.orgPermVersion = orgPermVersion
    user.templatePermVersion = templatePermVersion
    const userPerms = perms || []
    // clientType 0 网页；1 小程序
    let pcPerms = userPerms.filter(item => item.clientType === 0)
    // 过期校仅显示指定权限
    if (user.expiredSchool && pcPerms.length) {
      const allowPerms = ['考试批改', '错题管理', '阅卷帐号']
      pcPerms = Object.values(pcPerms).filter(s => !allowPerms.includes(s.permName))
    }
    const menus = transformMenu(pcPerms, 'pPermId')
    const pathArray = []
    pcPerms.forEach(menu => {
      pathArray.push(menu.permCode)
    })
    setRolesPerms(user.roles, pcPerms)
    YJ_SCHOOL_STORAGE.setItem('menus', JSON.stringify(menus))
    YJ_SCHOOL_STORAGE.setItem('pathArray', JSON.stringify(pathArray))
    // 清空缓存
    YJ_SCHOOL_STORAGE.removeItem('perm-cache')
    store.commit('LOGIN_SUCCESS', user)
  }
})

function transformMenu (datas, parentKey) {
  let dataArray = []
  datas.forEach(data => {
    const ID = data[parentKey]
    if (ID == '') {
      dataArray.push(data)
    }
  })
  dataArray = dataArray.sort((a, b) => {
    if (a.moduleOrder > b.moduleOrder) {
      return 1
    } else {
      return -1
    }
  })
  return data2treeDG(datas, dataArray, parentKey)
}

function data2treeDG (datas, dataArray, parentKey) {
  for (let j = 0; j < dataArray.length; j++) {
    const dataArrayIndex = dataArray[j]
    const childrenArray = []
    const CATL_CODEP = dataArrayIndex.id
    for (let i = 0; i < datas.length; i++) {
      const data = datas[i]
      const CATL_PARENT = data[parentKey]
      if (CATL_PARENT == CATL_CODEP) { // 判断是否为儿子节点
        childrenArray.push(data)
      }
    }
    if (childrenArray.length > 0) { // 有儿子节点则递归
      dataArrayIndex.children = childrenArray.sort((a, b) => {
        if (a.moduleOrder > b.moduleOrder) {
          return 1
        } else {
          return -1
        }
      })
      data2treeDG(datas, childrenArray, parentKey)
    }
  }
  return dataArray
}

function setRolesPerms (roles, perms) {
  if (!roles) return
  for (let index = 0; index < roles.length; index++) {
    const role = roles[index]
    if (!role.permIds) continue
    role.perms = []
    for (let pIndex = 0; pIndex < role.permIds.length; pIndex++) {
      const id = role.permIds[pIndex]
      const target = perms.find(item => item.id === id)
      if (target) {
        role.perms.push(target)
      } else {
        role.perms.push({ id })
      }
    }
  }
}
